import React from "react";
import { FormGroup } from "react-bootstrap";
import { Field } from "react-final-form";

export const FieldGroup = ( props ) => {
    const { groupId, groupName, groupLabel, groupHint, children, validator } = props
    const formGroupId = groupId.split( " " ).join( "" );
    return <Field name={ groupName } validate={ validator }>
        { ( { input, meta } ) => {
            return <FormGroup id={ formGroupId }
                              className={ (((meta.error && meta.modified) || !input.value) ? "has-error " : "is-success ") }>
                <label
                    className={ formGroupId + "_label " }>
                    { groupLabel }
                    { ((meta.error && meta.modified) || !input.value) &&
                    <div className="errorMessage"><span>Pick at least one option.</span></div> }
                </label>
                { groupHint && <p>
                    { groupHint }
                </p> }
                { children }
            </FormGroup>
        } }
    </Field>
}